import {isEmpty, cloneDeep} from 'lodash'

export default {
    name: 'EditAuthor',
    components: {
        ManageAuthor: () => import(/* webpackChunkName: "author" */ '../ManageAuthor/ManageAuthor.vue'),
        EditAuthorForm: () => import(/* webpackChunkName: "author" */ '../EditAuthorForm/EditAuthorForm.vue')
    },
    computed: {
        getFullName: function () {
            let name = this.claimTo.first_name ? this.claimTo.first_name : ''

            if(this.claimTo.middle_name !== '' && this.claimTo.middle_name !== undefined && this.claimTo.middle_name !== null){
                name = `${name} ${this.claimTo.middle_name}`
            }

            if(this.claimTo.last_name !== '' && this.claimTo.last_name !== undefined && this.claimTo.last_name !== null){
                name = `${name} ${this.claimTo.last_name}`
            }

            return name || this.claimTo.name
        }
    },
    beforeMount(){
        this.claimTo = cloneDeep(this.$store.getters.getInformationToEdit)
        if(isEmpty(this.$store.getters.getInformationToEdit)){
            this.$router.push('card')
        }
    },
    data(){
        return{
            claimTo: {}
        }
    },
    methods:{
        setClaimTo(claimTo){
            this.claimTo = claimTo
        }
    }
}